import { render, staticRenderFns } from "./pricingtable.vue?vue&type=template&id=72b5a287&"
import script from "./pricingtable.vue?vue&type=script&lang=js&"
export * from "./pricingtable.vue?vue&type=script&lang=js&"
import style0 from "./pricingtable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pricingtable.vue"
export default component.exports